import { Box, Tooltip, Typography } from '@mui/material'
import { Icon } from 'components'
import { theme } from 'config'
import React, { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Tree } from 'stores'
import { HierarchyTypes, TreeDataItem } from 'types'
import { TreeContext } from 'views'

export interface ITreeViewTooltipProps {
  item:     TreeDataItem
  children: ReactElement
}

export const TreeViewTooltip = (props: ITreeViewTooltipProps): JSX.Element => {
  const { item } = props
  const { t } = useTranslation()
  const tree: Tree = React.useContext(TreeContext)

  const depth = tree.getDepth(item.hierarchy_type)
  const is_quiz_attempts: boolean = // Course Attempts otherwise
    Array.from({ length: depth + 1 }, (_, idx) => idx + 1).some(
      (d) => tree.hierarchy[d - 1] === HierarchyTypes.Quiz
    )

  const is_program_duration: boolean =
    !depth || tree.hierarchy[depth - 1] === HierarchyTypes.Program // Program duration otherwise

  const isCompany: boolean = tree.hierarchy[depth] === HierarchyTypes.Company
  const isParticipant: boolean = tree.hierarchy[depth] === HierarchyTypes.User

  const tooltipLabel = () => {
    if (isCompany) {
      return t('fake_company_name') + ' ' + item.tree_id
    } else if (isParticipant) {
      return t('fake_user_name') + ' ' + item.tree_id
    } 
  }

  const content: ReactNode = (
    <Box gap={1}>
      <Typography fontWeight={theme.typography.fontWeightBold}> 
        {tree.show_fake_data ? tooltipLabel() : item.label}
      </Typography>
      <Box display='flex' flexDirection='row' gap={1} alignItems='center'>
        {is_quiz_attempts ? (
          <>
            <Icon size='size-16' iconId='three-arrows' />
            <Typography>{t('average_quiz_attempts')}:</Typography>
          </>
        ) : (
          <>
            <Icon size='size-16' iconId='three-arrows' />
            <Typography>{t('average_course_attempts')}:</Typography>
          </>
        )}
        <Typography>{Math.round(item.attempts)}</Typography>
      </Box>
      <Box display='flex' gap={1} flexDirection='row' alignItems='center'>
        {is_program_duration ? (
        <>
          <Icon size='size-16' iconId='clock'/>
          <Typography>{t('average_program_duration')}:</Typography>
        </>
        ) : (
          <>
            <Icon size='size-16' iconId='clock'/>
            <Typography>{t('average_course_duration')}:</Typography>
          </>
        )}
        <Typography>{Math.round(item.duration)}</Typography>
      </Box>
    </Box>
  )

  return (
    <Tooltip  title={content} arrow>
      {props.children}
    </Tooltip>
  )
}
